import { cloneDeep } from 'lodash'

export default function checklistItemById (state) {
  return (checklistItemId) => {
    return cloneDeep(state.checklistItems.find(item => item.id === checklistItemId)) || null
  }
}
